import { ServiceRequestBase } from "../ServiceRequestBase";

export class UserInfoRequest extends ServiceRequestBase {
  public Username: string | null = null;
  public EmailAddress: string | null = null;
}
